export default "__VITE_PUBLIC_ASSET__df88bddb__"